import { ApiError } from "../api/client";

import type { ApiErrorCode } from "../api/client";

const MESSAGES: Partial<Record<ApiErrorCode, string>> = {
  INVALID_CREDENTIALS: "아이디 또는 비밀번호가 올바르지 않습니다.",
  RATE_LIMITED: "요청이 너무 많습니다. 잠시 후 다시 시도해 주세요.",
  UNAUTHENTICATED: "로그인이 끝났습니다. 다시 로그인해 주세요.",
  CSRF_INVALID: "보안 확인에 실패했습니다. 새로고침 후 다시 시도해 주세요.",
  FORBIDDEN: "찾을 수 없거나 접근 권한이 없습니다.",
  RESOURCE_NOT_FOUND: "찾을 수 없거나 접근 권한이 없습니다.",
  ACCOUNT_DISABLED: "사용할 수 없는 계정입니다. 선생님께 문의해 주세요.",
  NAME_REQUIRED: "먼저 이름을 입력해 주세요.",
  CLASS_ARCHIVED: "보관된 학급입니다. 편집할 수 없습니다.",
  CANVAS_TRASHED: "휴지통으로 이동한 캔버스입니다.",
  VALIDATION_FAILED: "입력한 내용을 다시 확인해 주세요.",
  PREFIX_TAKEN: "이미 사용 중인 계정 접두어입니다.",
  LOGIN_ID_TAKEN: "이미 사용 중인 아이디입니다.",
  EMAIL_CODE_INVALID:
    "인증번호가 맞지 않거나 만료되었습니다. 다시 받아 주세요.",
  BETA_APPLICATION_EXISTS: "이미 신청된 이메일입니다.",
  MAIL_UNAVAILABLE:
    "지금은 메일을 보낼 수 없습니다. 잠시 후 다시 시도해 주세요.",
  SCHOOL_NOT_FOUND: "학교를 찾을 수 없습니다. 목록에서 다시 골라 주세요.",
  FRAME_NOT_SEALED: "마감한 내 프레임만 자랑할 수 있습니다.",
  GALLERY_POST_BLOCKED:
    "선생님이 내렸거나 확인 중인 작품이라 올릴 수 없습니다.",
  SCHOOL_REQUIRED: "선생님이 학교를 정하면 올릴 수 있습니다.",
  CONFLICT: "다른 변경과 겹쳤습니다. 새로고침 후 다시 시도해 주세요.",
  STALE_EPOCH: "캔버스가 복원되었습니다. 새로고침해 주세요.",
};

const FALLBACK = "서버에 연결할 수 없습니다. 잠시 후 다시 시도해 주세요.";

export const errorCodeOf = (error: unknown): ApiErrorCode =>
  error instanceof ApiError ? error.code : "NETWORK_FAILED";

export const errorMessage = (code: ApiErrorCode): string =>
  MESSAGES[code] ?? FALLBACK;

export const ErrorAlert = ({
  code,
  boxed = false,
  message = errorMessage(code),
}: {
  code: ApiErrorCode;
  boxed?: boolean;
  message?: string;
}) => (
  <p
    className={
      boxed ? "canvaschool-error canvaschool-error--box" : "canvaschool-error"
    }
    role="alert"
  >
    {message}
  </p>
);
